import TagsAnalytics from './TagsAnalytics';

export default TagsAnalytics;
